<template>
  <div style="width:100%;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    <div style="padding-top: 50px;" class="mater">

      <van-collapse v-model="activeNames">
        <div v-for="(item, index) in dataList">
          <van-collapse-item :title="item.requestUserName" :name="index">
            <div class="unitTitle">详细信息</div>
            <b-table sticky-header="calc(100vh - 50px)" class="bgc-dark" head-variant="dark" responsive bordered
                     :items="item.costEventClaimDetailDTOList" :fields="fields1">
              <template v-slot:head()="scope">
                <div class="text-nowrap" :style="{textAlign:'center'}">
                  {{ scope.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:table-colgroup="scope">
                <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width:  field.key === 'index' ?'30px':(field.key === 'budgetUsedAmount'||field.key === 'budgetApportionAmount')? '140px':'100px',left: '80px'}"
                />
              </template>
            </b-table>
            <van-field v-model="item.personYearAmount" label="报销人本年累计（元）" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <div class="unitTitle">发票明细</div>
            <b-table striped small sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
                     :items="item.costInvoiceDTOList" :fields="fields2" foot-clone>
              <template v-slot:head()="scope">
                <div class="text-nowrap" :style="{textAlign:'center'}">
                  {{ scope.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(amount)="data">
                {{ Number(data.item.amount).toFixed(2)}}
              </template>
              <template v-slot:table-colgroup="scope">
                <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width:  field.key === 'index' ?'50px':(field.key === 'budgetUsedAmount'||field.key === 'budgetApportionAmount')? '140px':'100px',left: '80px'}"
                />
              </template>
              <template v-slot:foot()="scope">
                <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
              </template>
              <template v-slot:foot(index)="data">
                <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
              </template>
              <template v-slot:foot(amount)="data">
                <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{sumNum(item.costInvoiceDTOList,'amount')}}</div>
              </template>
            </b-table>
          </van-collapse-item>
        </div>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import {BTable} from 'bootstrap-vue'


export default {
  data() {
    return {
      activeNames:[0],
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'businessTypeName',stickyColumn: true,  label: '业务类型'},
        {key: 'startDate', label: '开始日期'},
        {key: 'endDate', label: '结束日期'},
        {key: 'departurePlace', label: '出发地'},
        {key: 'destinationPlace', label: '目的地'},
        {key: 'vehicles', label: '交通工具'},
        {key: 'person', label: '参与人员'},
        {key: 'mealAmount', label: '餐费（元）'},
        {key: 'hotelAmount', label: '住宿费（元）'},
        {key: 'trafficAmount', label: '交通费（元）'},
        {key: 'otherAmount', label: '其他费用（元）'},
        {key: 'requestAmount', label: '报销金额（元）'},
        {key: 'budgetSubjectCode', label: '预算科目编号'},
        {key: 'budgetSubjectFullName', label: '预算科目名称'},
        {key: 'budgetAmount', label: '预算金额（元）'},
        {key: 'budgetUsedAmount', label: '预算已使用金额（元）'},
        {key: 'accountSubjectFullName', label: '核算科目'},
        {key: 'remarks', label: '备注'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'invoiceNum',stickyColumn: true,  label: '发票号码'},
        {key: 'invoiceType', label: '发票类型'},
        {key: 'purchaserName', label: '购方名称'},
        {key: 'sellerName', label: '销售方名称'},
        {key: 'amount', label: '发票金额（元）'},
      ],
      dataList: [],
      layoutHeight: '0px',
      time: 0
    }
  },
  mounted() {
  },
  created() {
    this.$nextTick(() => {
      this.layoutHeight = document.documentElement.clientHeight - 50 + 'px';
      let query = this.$route.query;
      this.dataList = query.dataList
      console.log(this.dataList)
    });
  },
  methods: {
    init() {
    },
    joint(data) {
      this.items.forEach(i => {
        i.materialData = {}
        data.forEach(key => {
          i.materialData[key] = i[key]
        })
      })
    },
    goBack() {
      this.$router.go(-1);
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
  }
}
</script>

<style scoped>
.mater tr th:nth-child(2),.mater tr td:nth-child(2) {
  left: 30px !important;
}

.unitTitle {
  width: 100%;
  padding-left: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
</style>
